import React from "react";
import CustomerClickBoard from "./CustomerClickBoard";

const RequestDataVisualizationCustomer = () => <CustomerClickBoard scope="own" />;

export default RequestDataVisualizationCustomer;
